import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '../services/translate.service';

@Pipe({
    name: 'tagName',
    standalone: true,
})
export class TagNamePipe implements PipeTransform {
    constructor(private readonly translateService: TranslateService) {}

    transform(value: string): unknown {
        const parts = value.split('|');
        const params = {
            i: parts.length > 1 ? parts[1] : '',
        };
        return this.translateService.get(parts[0], params).trim();
    }
}
